<p-table [value]="stats" [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="header">
        <tr>
            <th>{{ 'files.stats.dateTime' | translate }}</th>
            <th>{{ 'files.stats.name' | translate }}</th>
            <th>{{ 'files.stats.type' | translate }}</th>
            <th>{{ 'files.stats.ip' | translate }}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-stat>
        <tr>
            <td>{{ stat.date | localDate }}</td>
            <td>{{ stat.userName }}</td>
            <td>{{ 'files.stats.values.' + stat.type | translate }}</td>
            <td>{{ stat.ip }}</td>
        </tr>
    </ng-template>
</p-table>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons [primaryButtonVisibility]="false"
        (secondaryClickEvent)="dialogRef.close()"></app-action-buttons>
</div>
